import { WithFile } from '@common/typescript/objects/WithFile';
import { List } from '@common/typescript/objects/List';

import { BaseInsurance } from '@commonTuna/react/objects/BaseInsurance';

import { User } from '@app/objects/User';
import { CardImageType } from '@app/objects/CardImageType';

export interface InsuranceImage extends WithFile<Insurance> {
	cardImageType: CardImageType;
}

export enum InsurancePriority {
	NoPriority = 0,
	Primary = 1,
	Secondary = 2,
	Tertiary = 3
}

export interface Insurance extends BaseInsurance {
	user: User;
	userId: number;

	photoFront: string;
	photoBack: string;

	insurancePriority: InsurancePriority;

	files: List<InsuranceImage>;
}
